import { connect } from "react-redux";
import { Field, Form, FormSpy } from "react-final-form";

import InputText from "@components/Form/InputText";
import Select from "@components/Form/Select";
import { getRegions } from "@store/user/actions";
import getAvailableCitiesInRegion from "@components/GoogleMap/_lib/getAvailableCitiesInRegion";

const GoogleMapFilters = ({ data, regions, onFiltersChange }) => {
  const handleFormChange = ({ formState, form }) => {
    const { values, active } = formState;

    if (!active) {
      return;
    }

    switch (active) {
      case "region": {
        handleRegionChange({ values, form, active });
        break;
      }
      case "city": {
        handleCityChange({ values, form, active });
        break;
      }
      case "search": {
        handleSearchChange({ values, form, active });
        break;
      }
      default:
        return;
    }
  };

  const handleRegionChange = ({ values, form, active }) => {
    const { region, city, search } = values;
    if (!active || !region) {
      return;
    }

    if (city && city !== "all_cities") {
      form.change("city", "all_cities");
    }

    if (search) {
      form.change("search", null);
    }

    onFiltersChange({ value: region, active });
  };

  const handleCityChange = ({ values, form, active }) => {
    const { city, search } = values;

    if (!active || !city) {
      return;
    }

    if (search) {
      form.change("search", null);
    }

    onFiltersChange({ value: city, active });
  };

  const handleSearchChange = ({ values, form, active }) => {
    const { search } = values;

    if (!active) {
      return;
    }

    const { visited, modified } = form.getState();

    // we send emty string if search was cleared, to know that a value was previously entered
    const searchValue =
      visited.search && !modified.search
        ? null
        : modified.search && search?.length
        ? search
        : "";

    onFiltersChange({ value: searchValue, active });
  };

  return (
    <Form
      onSubmit={() => null}
      render={({ values, form }) => (
        <form onSubmit={(e) => e.preventDefault()}>
          <FormSpy
            onChange={(formState) => handleFormChange({ formState, form })}
          />

          {regions && (
            <>
              <Field
                component={Select}
                label="Judet"
                name="region"
                id="GoogleMap_regionFilter"
                inputClassName="!max-w-full"
              >
                <option value="all_regions">Toate judetele</option>

                {regions &&
                  regions.map((region) => (
                    <option key={region.id} value={region.url_key}>
                      {region.name}
                    </option>
                  ))}
              </Field>

              <div className="mt-[8px]">
                <Field
                  component={Select}
                  label="Localitate"
                  name="city"
                  disabled={!values.region || values.region === "all_regions"}
                  id="GoogleMap_cityFilter"
                  inputClassName="!max-w-full"
                >
                  <option value="all_cities">Toate localitatile</option>

                  {getAvailableCitiesInRegion({
                    data,
                    region: values.region,
                  }).map((city) => (
                    <option key={city} value={city}>
                      {city}
                    </option>
                  ))}
                </Field>
              </div>
            </>
          )}

          <div className="mt-[8px]">
            <Field
              component={InputText}
              label="Cauta punct de ridicare"
              name="search"
              id="GoogleMap_searchFilter"
              inputClassName="!max-w-full"
            />
          </div>
        </form>
      )}
    />
  );
};

export default connect((state) => ({ regions: state.user.regions }), {
  getRegions,
})(GoogleMapFilters);
